import { render } from "./StandDialog.vue?vue&type=template&id=65b0b9d0&scoped=true&ts=true"
import script from "./StandDialog.vue?vue&type=script&lang=ts"
export * from "./StandDialog.vue?vue&type=script&lang=ts"

import "./StandDialog.vue?vue&type=style&index=0&id=65b0b9d0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b0b9d0"]])

export default __exports__